(function() {
	'use strict';

	angular.module('FYN').controller('TestController', function($scope) {

		angular.element('title').text('This is a test');
		

	});
})();